import { OVERFLOW_QUALITY_WARNING } from './OverflowUnlockTimer'
import { useOfferReset } from '@/hooks/useOfferReset'
import { isWithinHoursOfReset } from '@/utils/timer'

export { OVERFLOW_QUALITY_WARNING }

interface OverflowQualityWarningProps {
  className?: string
}

export function OverflowQualityWarning({ className = '' }: OverflowQualityWarningProps) {
  // Against THIS offer's reset — on a Pacific offer, "3 hours before midnight UTC" is the
  // middle of its day and would surface the warning at the wrong time entirely.
  const { nextReset } = useOfferReset()
  if (!isWithinHoursOfReset(3, nextReset)) return null
  return (
    <div
      className={
        'rounded-lg border border-amber-300/60 bg-amber-50 px-3 py-2.5 dark:border-amber-500/30 dark:bg-amber-500/10 ' +
        className
      }
    >
      <p className="text-xs text-amber-800 dark:text-amber-200/90">{OVERFLOW_QUALITY_WARNING}</p>
    </div>
  )
}
